import React, { useCallback, useState } from "react";
import { Icon } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import "./style.scss";
import QAWidgetTheming from "./theming";
import QAWidgetSeo from "./SEO";
import QAWidgetProfile from "./profile";
import QABroadcaster from "./Viewer";
import TailwindFlex from "library/components/_tailwind/flex";
import TailwindTabs from "library/components/_tailwind/tabs";
import { Tab } from "library/components/_tailwind/tabs/types";
import QAWidgetDevices from "containers/_layout/_components/qa-widget/devices";
import QAWidgetBroadcastShowTrail from "containers/_layout/_components/qa-widget/show-trail";
import QAWidgetMisc from "containers/_layout/_components/qa-widget/misc";
import { MODAL_WRAPPER_CLASSNAME } from "library/core/stores/modal/consts";
import UpcomingFeatures from "./upcoming-features";
import QABroadcastConfig from "./broadcast-config";
import QAWidgetProduction from "./production";
import { FEATURE_FLAGS } from "core/stores/auth/feature-flags";
import config from "core/config";
import AuthStore from "core/stores/auth/AuthStore";

type Props = {
  authStore?: AuthStore;
};

const QAWidget: React.ComponentType<Props> = ({ authStore }) => {
  const [shouldShowWidget, setShouldShowWidget] = useState<boolean>(false);
  const [activeTabId, setActiveTabId] = useState<number>(0);

  const { env, modelsUrl, studiosUrl } = config;

  // Check if QA Widget should be shown
  const shouldShowQAWidget =
    authStore!.isFeatureEnabled(FEATURE_FLAGS.FEATURE_QA_WIDGET) ||
    env !== "production" ||
    (modelsUrl.includes("models.qa") && studiosUrl.includes("studios.qa"));

  const tabs: Tab[] = [
    {
      id: "1",
      label: "Theming",
      component: <QAWidgetTheming />,
    },
    {
      id: "2",
      label: "SEO",
      component: <QAWidgetSeo />,
    },
    {
      id: "3",
      label: "Profile",
      component: <QAWidgetProfile />,
    },
    {
      id: "4",
      label: "Broadcaster",
      component: <QABroadcaster />,
    },
    {
      id: "5",
      label: "Devices",
      component: <QAWidgetDevices />,
    },
    {
      id: "6",
      label: "Show Trail",
      component: <QAWidgetBroadcastShowTrail />,
    },
    {
      id: "7",
      label: "Misc",
      component: <QAWidgetMisc />,
    },
    {
      id: "8",
      label: "Broadcast Config",
      component: <QABroadcastConfig />,
    },
    {
      id: "9",
      label: "Upcoming Features",
      component: <UpcomingFeatures />,
    },
    {
      id: "10",
      label: "Production",
      component: <QAWidgetProduction />,
    },
  ];

  const onChangeShouldShowWidget = useCallback(() => {
    setShouldShowWidget(!shouldShowWidget);
  }, [shouldShowWidget]);

  const onTabChange = useCallback(tab => {
    setActiveTabId(tab);
  }, []);

  if (!shouldShowQAWidget) {
    return null;
  }

  return (
    <TailwindFlex
      width={"w-auto"}
      className={["FeatureSwitch__Cobrand"]}
      padding={!shouldShowWidget ? ["p-0"] : undefined}>
      <TailwindFlex
        display={shouldShowWidget ? "flex" : "hidden"}
        height={"h-full"}>
        <TailwindTabs
          onChange={value => onTabChange(value)}
          activeTabIndex={activeTabId}
          tabs={tabs}
          height={"h-full"}
          headerProps={{
            fitWidthAndScrollHorizontally: true,
          }}
          bodyProps={{
            flexGrow: "flex-grow",
            flexDirection: "flex-col",
            height: "h-full",
            className: [MODAL_WRAPPER_CLASSNAME, "FeatureSwitch__Cobrand__tab"],
          }}
        />
      </TailwindFlex>
      <div
        className='FeatureSwitch__Cobrand-hide-button'
        onClick={onChangeShouldShowWidget}>
        <Icon>code</Icon>
      </div>
    </TailwindFlex>
  );
};

export default inject("authStore")(observer(QAWidget));
